var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.9976 46.9326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "plus_iconElement 167") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Isolationsmodus_Kopie",
    "data-name": "Isolationsmodus Kopie"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.97868,24.167A23.1415,23.1415,0,0,1,23.41227,46.9326q-.46,0-.92383-.0166A22.904,22.904,0,0,1,6.28922,39.30174,24.02976,24.02976,0,0,1,.03727,21.85838C.7443,9.39451,12.07829-.60256,24.78629.0283A22.85489,22.85489,0,0,1,46.97868,24.167Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.74607,24.82908c-3.10638-.18164-6.21563-.28125-9.32544-.3313l-.43469,9.54566c-.07306,1.60474-2.57324,1.6084-2.5,0l.12122-2.66211q.15756-3.4596.31506-6.91919-5.33643-.02528-10.67169.20081c-1.61121.07031-1.60254-2.43006,0-2.5q5.39089-.23529,10.78558-.2013.20655-4.53643.41315-9.07275c.07306-1.60474,2.57324-1.6084,2.5,0L25.828,15.551,25.53434,22c3.0719.051,6.14325.14978,9.21173.3291C36.34782,22.42271,36.35325,24.92308,34.74607,24.82908Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.ac8f08acef1a0129d5315ffa10c3743f.svg";
export { ForwardRef as ReactComponent };